import script from "./ChatSettingsAll.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatSettingsAll.vue?vue&type=script&setup=true&lang=ts"

import "./ChatSettingsAll.vue?vue&type=style&index=0&id=1720cadc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1720cadc"]])

export default __exports__